export default {"src":"/_next/static/media/incorrect_answer.6eb0b464.svg","height":256,"width":256,"blurWidth":0,"blurHeight":0};